import { render, staticRenderFns } from "./cartao.vue?vue&type=template&id=6a306f10&scoped=true&"
import script from "./cartao.vue?vue&type=script&lang=js&"
export * from "./cartao.vue?vue&type=script&lang=js&"
import style0 from "./cartao.vue?vue&type=style&index=0&id=6a306f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a306f10",
  null
  
)

export default component.exports